<app-kontable title = "{{ 'languageList.sectionTitle' | translate }}"
              [columns] = "['id', 'iso_code', 'language', 'nls_code']"
              [titles] = "['common.id', 'common.isoCode', 'common.language', 'common.nlsCode']"
              [showInfoButton]="false"
              [showRecoverButton]="true"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [service]="srvLanguage"
              [paginationType]="paginationType"
              (onAdd)="showAddOrEditDialog($event)"
              (onEdit)="showAddOrEditDialog($event)"
              (onRemove)="delete($event)"
              (onRecover)="recover($event)"
              [(fireNewDataAvailable)]="newDataAvailable"
></app-kontable>

<p-dialog *ngIf="srvLanguage.languageEditing"
          [width]="500"
          [(visible)]="srvLanguage.languageEditing"
          [responsive]="true"
          header="{{modalTitle}}"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

    <kv-language-form [dialogBoxLanguage]="srvLanguage.languageEditing"
                      (languageAdded)="languageAdded($event)"
                      (languageUpdated)="languageUpdated($event)">
    </kv-language-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/language/language.component.html